import axios from 'axios'
import otf from 'object-to-formdata'
import {ElMessage} from 'element-plus'
import humps from 'humps'
import qs from 'qs'
import config from './config'

const copySysId = process.env.COPY_SYS_ID || '1'

const instance = axios.create({
  baseURL: config.baseUrl,
  timeout: 10000,
  withCredentials: true,
  // headers: {
  //   'Content-type': 'application/x-www-form-urlencoded'
  // }
  paramsSerializer: function (params) {
    // 只有GET会进这里
    return qs.stringify(humps.decamelizeKeys(params), { arrayFormat: 'brackets' })
  }
})

instance.interceptors.request.use(
  config => {
    let {
      params,
      data,
      formData
    } = config
    if (!config.headers) {
      config.headers = {}
    }
    if (copySysId) {
      config.headers['X-Copy-Sys-Id'] = copySysId
    }
    // 驼峰转下划线
    // params （查询字符串） 在 paramsSerializer 中处理过了
    // 这里处理 data 即可
    const translatedFormData = new FormData()
    if (data && !formData) {
      data = humps.decamelizeKeys(data)
    }
    if (formData) {
      const form = otf.serialize(data)
      const formKeys = form.keys()
      while (true) {
        const {
          done,
          value
        } = formKeys.next()
        if (done) {
          break
        }
        translatedFormData.append(humps.decamelize(value), form.get(value))
      }
      config.headers['Content-Type'] = 'multipart/form-data'
    }
    return {
      ...config,
      params,
      data: formData ? translatedFormData : data
    }
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    if (dataAxios.message) {
      ElMessage({
        message: dataAxios.message,
        type: 'success'
      })
    }
    return humps.camelizeKeys(dataAxios)
  },
  error => {
    const status = error.response.status

    if (status === 401) {
      window.location.href = '/login'
    }
    if (status === 404) {
      ElMessage({
        message: '记录不存在或者已被删除',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
    }
    return Promise.reject(error)
  }
)

export default instance
